//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
    logEventStatistics,
    pageViewStatistics
} from '@/util/const'
export default {
    name: "awardPoints",
    data() {
        return {
            lang: '',
            ruleShow: false,
        }
    },
    methods: {
        jump(){
            logEventStatistics({
                umkey: 'Refill_Q2Campaign_button',
            })
            window.location.href = 'openhkhshlogin://cmcchkhsh://prepaidCardValueAdded'
        }
    },
    destroyed() {
        // 页面离开统计
        pageViewStatistics({
            pageId: 'Refill_Q2Campaign_PVUV',
            start: 0
        })
    },
    created() {
        // 页面进入统计
        pageViewStatistics({
            pageId: 'Refill_Q2Campaign_PVUV',
            start: 1
        })
        this.lang = window.localStorage.lang
        document.title = this.$t('other.awardPoints.t1')
    }
}



// WEBPACK FOOTER //
// ./src/page/other/awardPoints.vue